var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gg:instagram",
    clipPath: "url(#clip0_1429_1236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88123 6.32568C8.8292 6.32568 7.82026 6.7436 7.07637 7.4875C6.33247 8.2314 5.91455 9.24034 5.91455 10.2924C5.91455 11.3444 6.33247 12.3533 7.07637 13.0972C7.82026 13.8411 8.8292 14.2591 9.88123 14.2591C10.9333 14.2591 11.9422 13.8411 12.6861 13.0972C13.43 12.3533 13.8479 11.3444 13.8479 10.2924C13.8479 9.24034 13.43 8.2314 12.6861 7.4875C11.9422 6.7436 10.9333 6.32568 9.88123 6.32568ZM7.50122 10.2924C7.50122 10.9236 7.75197 11.529 8.19831 11.9753C8.64465 12.4216 9.25002 12.6724 9.88123 12.6724C10.5125 12.6724 11.1178 12.4216 11.5642 11.9753C12.0105 11.529 12.2612 10.9236 12.2612 10.2924C12.2612 9.66115 12.0105 9.05578 11.5642 8.60945C11.1178 8.16311 10.5125 7.91236 9.88123 7.91236C9.25002 7.91236 8.64465 8.16311 8.19831 8.60945C7.75197 9.05578 7.50122 9.66115 7.50122 10.2924Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6415 4.73901C14.4311 4.73901 14.2293 4.8226 14.0805 4.97138C13.9317 5.12016 13.8481 5.32194 13.8481 5.53235C13.8481 5.74276 13.9317 5.94454 14.0805 6.09332C14.2293 6.2421 14.4311 6.32569 14.6415 6.32569C14.8519 6.32569 15.0537 6.2421 15.2025 6.09332C15.3512 5.94454 15.4348 5.74276 15.4348 5.53235C15.4348 5.32194 15.3512 5.12016 15.2025 4.97138C15.0537 4.8226 14.8519 4.73901 14.6415 4.73901Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32813 1.56567C3.48651 1.56567 2.67935 1.90001 2.08424 2.49513C1.48912 3.09024 1.15479 3.8974 1.15479 4.73902V15.8457C1.15479 16.6874 1.48912 17.4945 2.08424 18.0896C2.67935 18.6847 3.48651 19.0191 4.32813 19.0191H15.4348C16.2765 19.0191 17.0836 18.6847 17.6787 18.0896C18.2739 17.4945 18.6082 16.6874 18.6082 15.8457V4.73902C18.6082 3.8974 18.2739 3.09024 17.6787 2.49513C17.0836 1.90001 16.2765 1.56567 15.4348 1.56567H4.32813ZM15.4348 3.15235H4.32813C3.90732 3.15235 3.50374 3.31951 3.20618 3.61707C2.90863 3.91463 2.74146 4.31821 2.74146 4.73902V15.8457C2.74146 16.2665 2.90863 16.6701 3.20618 16.9677C3.50374 17.2652 3.90732 17.4324 4.32813 17.4324H15.4348C15.8557 17.4324 16.2592 17.2652 16.5568 16.9677C16.8544 16.6701 17.0215 16.2665 17.0215 15.8457V4.73902C17.0215 4.31821 16.8544 3.91463 16.5568 3.61707C16.2592 3.31951 15.8557 3.15235 15.4348 3.15235Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1429_1236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0401,
    height: 19.0401,
    fill: "white",
    transform: "translate(0.361328 0.772644)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramDoodle);
export default __webpack_public_path__ + "static/media/instagramDoodle.e0721d1937cbc3ebe105ad57757f6ad7.svg";
export { ForwardRef as ReactComponent };